<template>
  <main-sidebar :name="sidebarName" :title="$t('add_payment')">
    <div class="p-4">
      <vs-row vs-w="12" class="mb-2">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{$t('vendor')}}</label>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-2">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label >{{vendorName}}</label>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-2">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="8"
        >
          <vs-input
          name="total"
            icon-pack="feather"
            icon="icon-dollar-sign"
            placeholder="Monto total"
            icon-no-border
            class="w-full mr-1"
            v-model.number="payment.amount"
            v-validate="{decimal:2}"
            autocomplete="off"
          />
        </vs-col>
        
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="4"
        >
        <vs-input
            placeholder="Currency"
            icon-no-border
            v-model="payment.currency"
            disabled
            class="w-full  ml-1"
          />
          </vs-col>
      </vs-row>
      <vs-col vs-w="12">
              <span
                class="text-danger text-sm"
                v-show="errors.has('total')"
              >{{ errors.first('total') }}</span>
            </vs-col>
      <vs-row vs-w="12" class="mb-2">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            :options="options"
            class="w-full"
            :placeholder="$t('payment_method')"
            v-model="payment.method"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-2">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <vs-input
            icon-pack="feather"
            icon="icon-hash"
            :placeholder="$t('policy')"
            icon-no-border
            class="w-full"
            v-model="payment.policy"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-justify="center" class="mb-4">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <UploadFile
            v-model="payment.files"
            list
            btnColor="primary"
            class="w-full"
            btnClass="w-full"
            accept="application/pdf"
          />
        </vs-col>
      </vs-row>
    </div>

    <div slot="footer" class="mx-4">
      <vs-button  color="success" type="border" class="mr-6" @click="passPayParams">
      {{$t('add_payment')}}
      </vs-button>

    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import vSelect from 'vue-select'
import UploadFile from '@/views/components/UploadFile'
export default {
  components: {
    MainSidebar,
    vSelect,
    UploadFile
  },
  props:{
    paymentInfo:{
      type: Object,
      default:()=>{}
    },
    vendorProp:{
      type:Object,
      default:()=>{}
    }
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.sidebarName
    },
    isLoading() {
      return false
    },
    isFormValid () {
      return (!this.errors.any() 
      && this.payment.method !== '' 
      && this.payment.policy !== '' 
      && this.payment.amount !== ''
      && this.payment.amount !== null
      && this.payment.files.length > 0 )
    },
    currentLocale() {
      return this.$i18n.locale
    }
  },
   watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
    isLoading(val) {
      if (val) {
        this.openLoading()
      } else {
        this.closeLoading()
      }
    },
    currentLocale() {
      this.options= [
        { label: this.$i18n.messages[this.currentLocale].transfer, value: 'TRANSFER' },
        { label: this.$i18n.messages[this.currentLocale].check, value: 'CHECK' }
      ]
    }
  },
  data() {
    return {
      vendorName:'',
      sidebarName: 'register-pay',
      payment:{
        amount:null,
        method:'',
        policy:'',
        files:[],
        currency:'MXN'
      },
      options: [
        { label: this.$i18n.messages[this.$i18n.locale].transfer, value: 'TRANSFER' },
        { label: this.$i18n.messages[this.$i18n.locale].check, value: 'CHECK' }
      ]
    }
  },
  methods: {
    init(){
      this.payment = {
        amount:null,
        method:'',
        policy:'',
        files:[],
        currency:this.paymentInfo.currency
      }
      this.vendorName=this.vendorProp.name
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    openLoading() {
      this.$vs.loading({
        container: `#loading-${this.sidebarName}-sidebar`,
        scale: 0.6
      })
    },
    closeLoading() {
      this.$vs.loading.close(`#loading-${this.sidebarName}-sidebar > .con-vs-loading`)
    },
    passPayParams(){
      this.$emit('sendPay',this.payment)
    }
  }
}
</script>

<style></style>
